import './app.less';

import '../user';

const ua = navigator.userAgent;
const isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);
if (isMobile) {
  location.href = '/index.html';
}

import config from '../config';
const accountUrl = config.accountUrl ;
const apiUrl = config.apiUrl ;
const caimiUrl = config.caimiUrl ;
const facedetectUrl = config.facedetectUrl ;
const httpProtocol = config.httpProtocol ;
const loginDirect = config.loginDirect ;
const registerDirect = config.registerDirect ;
const webUrl = config.webUrl ;
const staticUrl = config.staticUrl ;
const spmMark = 'xhzy_mp_index';

// 设置跳转链接
const urlArr = [
  {
    name: 'LoginUrl',
    url: `${loginDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'RegisterUrl',
    url: `${registerDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'CopyrightLogin',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/banquan/all?from=${spmMark}`)}`
  }, {
    name: 'TTSLoginUrl',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/tts?from=${spmMark}`)}`
  }, {
    name: 'FenfaLoginUrl',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/fenfa?from=${spmMark}`)}`
  }, {
    name: 'CaimiUrl',
    url: `${caimiUrl}?from=${spmMark}`
  }, {
    name: 'FaceDetectUrl',
    url: `${facedetectUrl}?from=${spmMark}`
  }, {
    name: 'LiveUrl',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/persona?from=${spmMark}`)}`
  }
];

urlArr.map((item) => {
  $('.' + item.name).attr('href', item.url);
});

$('.product-item').click((e) => {
  const hasMobile = $(e.currentTarget).hasClass('mobile');
  $('.product-item').removeClass('mobile');
  if (hasMobile) return;
  $(e.currentTarget).addClass('mobile');
});

// 处理不同浏览器高度的页面展示区域内容
function resize(argument) {
  const bh = $('body').height();
  const wh = $(window).height();
  if (bh < wh) {
    const newHeight = parseFloat(wh) - 60 - 125;
    if (newHeight < 600) return;
    $('.content > .container').css({
      height: newHeight + 'px',
    })
  }
};

// resize();

// $(window).resize(() => {
//   console.log('resize')
//   resize();
// });




// WEBPACK FOOTER //
// ./src/pages/contact/app.js